<template>
  <div class="static-page faq">

    <section class="static-page__hero">
      <div class="static-page__hero-backdrop">
        <img class="static-page__hero-image"  src="assets/images/alpitour/statics/viaggia-con-noi-hero.jpg" alt="viaggia con noi hero" />
      </div>
      <div class="static-page__hero-content">
        <b-container class="d-flex">
          <vb-icon :name="'symbol_vv'" />
          <div class="static-page__hero-heading">
            <h1 class="vb-heading" v-html="'<span>Per prenotare un viaggio con '+ site.brand + ' ' + site.payoff +'</span><br><span>bastano pochi click</span>'" />
          </div>
        </b-container>
      </div>
    </section>

    <section class="section">
      <b-container>
        <p class="mb-5" v-html="'Il servizio è dedicato ad utenti titolari di <strong>crediti di welfare aziendale</strong> ed è disponibile sui più importanti portali di welfare aziendale italiani. Contatta l’ufficio personale della tua azienda o l’assistenza del tuo portale welfare per sapere se ' + site.brand + ' ' + site.payoff + ' è stato attivato.'" />
        <h2 class="vb-heading h1" v-html="'Domande frequenti'" id="domande-frequenti" />
      </b-container>
    </section>

    <section class="section" id="prenota-un-viaggio">
      <b-container>
        <h3 v-html="'Come posso <span class=\'text-secondary\'>prenotare</span> un viaggio?'" />
        <ul>
          <li v-html="'Per prenotare un viaggio devi accedere al <strong>portale welfare</strong> della tua azienda, cercare il servizio <strong>' + site.brand + ' ' + site.payoff + '</strong> e accedere al nostro sito.'" />
          <li v-html="'A quel punto potrai prenotare pacchetti viaggio o servizi turistici Solo soggiorno in decine e decine di destinazioni.'" />
        </ul>
      </b-container>
    </section>

    <section class="section">
      <b-container>
        <value-proposition
            :vp="[
                  {
                    vp_image: 'assets/images/alpitour/statics/viaggia-con-noi-by-vadobay.jpg',
                    vp_content: [
                      {
                        vp_icon: 'symbol_vv',
                        vp_title: '<span>Cosa posso prenotare su ' + site.brand + ' ' + site.payoff + '?</span>',
                        vp_text: `<p>Su ${site.brand} ${site.payoff} puoi prenotare:</p><ul><li class='mb-2'><strong>Pacchetti Volo e soggiorno:</strong> comprendono il soggiorno in hotel e il volo (charter o di linea), con eventuali trasferimenti.</li><li><strong>servizi Solo Soggiorno:</strong> includono solo il soggiorno in hotel, senza volo né trasferimenti.</li></ul><p>Scegli la tipologia che preferisci navigando sui tab proposti nel booking engine in home page.</p>`
                      }
                    ]
                  }
                ]"
        />
      </b-container>
    </section>

    <section class="section">
      <b-container>
        <h3 v-html="'Quali <span class=\'text-secondary\'>bagagli</span> sono inclusi nei biglietti aerei?'" />
        <p><em>Le seguenti informazioni valgono solo per i pacchetti che includono il volo.</em> Se scegli un <strong>Solo Soggiorno</strong>, il trasporto non è incluso e raggiungerai la struttura con mezzi propri. <br/>L’assistenza si svolge tramite il nostro call center oppure il personale in loco.</p>
        <p v-html="'Quando prenoti un pacchetto Volo e soggiorno, i biglietti aerei includono sempre il trasporto di un bagaglio a mano e di un bagaglio in stiva per ogni adulto e per ogni bambino partecipanti al viaggio. Per le specifiche franchigie contatta la nostra assistenza una volta individuato il pacchetto che ti interessa.'" />
      </b-container>
    </section>

    <section class="section">
      <b-container>
        <h3 v-html="'Sono richiesti <span class=\'text-secondary\'>visti e/o passaporti o vaccinazioni</span> obbligatorie?'" />
        <p v-html="'Questo dipende dalla destinazione del tuo viaggio. Ti invitiamo a visitare il sito <a href=\'https://www.viaggiaresicuri.it\' target=\'_blank\'>Viaggiaresicuri.it</a> del Ministero degli esteri italiano ed, eventualmente, a contattare l\'ambasciata o il consolato del Paese di destinazione del tuo viaggio per avere maggiori informazioni.'" />
      </b-container>
    </section>

    <section class="section">
      <b-container>
        <h3 v-html="'Cosa include l\'<span class=\'text-secondary\'>assicurazione medico bagaglio</span>?'" />
          <services-insurance class="services-insurance" />
      </b-container>
    </section>

    <section class="section">
      <b-container>
        <h3 v-html="'Cosa è incluso nelle prenotazioni di servizi turistici Solo Soggiorno?'" />
        <p v-html="'Nelle prenotazioni Solo Soggiorno sono inclusi i pernotti cosi come indicati nella conferma di prenotazione unitamente ai trattamenti cosi come descritti nella conferma stessa. Queste prenotazioni prevedono la <strong>cancellazione senza penali</strong> fino a 12 giorni prima della data di checkin.'" />
      </b-container>
    </section>

    <section class="section">
      <b-container>
        <h3 v-html="'Come faccio ad accedere alle proposte ' + site.brand + ' ' + site.payoff + '?'" />
        <p v-html="'Per accedere ai nostri servizi online bisogna effettuare login sul portale welfare della tua azienda, cercare ' + site.brand + ' ' + site.payoff + ' e accedere al nostro sito. Contatta il tuo ufficio risorse umane o il tuo portale di welfare aziendale per avere maggiori informazioni su come fruire dei nostri servizi.'" />
      </b-container>
    </section>

    <section class="section">
      <b-container>
        <h3 v-html="'Cosa può offrirti <span class=\'text-secondary\'>l’assistenza</span> di Vadobay?'" />
        <ul>
          <li v-html="'<strong>Consigli sulle destinazioni.</strong> Contattaci tramite uno dei nostri canali che trovi in fondo a questa pagina e cercheremo di fare il possibile per aiutarti a trovare la vacanza dei tuoi sogni.<br>Ti ricordiamo che la prenotazione deve essere fatta in autonomia sul nostro sito, non ci è quindi possibile prenotare per te.'" />
          <li v-html="'<strong>Invio dei documenti di viaggio</strong> pochi giorni prima della partenza.<br>Se necessiti di informazioni specifiche prima del ricevimento dei documenti di viaggio non esitare a contattare la nostra assistenza.'" />
        </ul>
      </b-container>
    </section>

    <section class="section" id="credito-non-sufficiente" v-if="get_config('integration.welfare')">
      <b-container>
        <div class="static-page__quote">
          <vb-icon :name="'quote'" :color="sass('secondary')" />
          <h3 class="static-page__quote-title vb-heading h1" v-html="'Credito non sufficiente? Contattaci'" />
          <vb-icon :name="'quote'" :color="sass('secondary')" />
        </div>
        <p>
          Se il tuo credito welfare non è sufficiente puoi
          <customer-support-action cta_id="alpitour-viaggia-con-noi-insufficient-credit">contattarci</customer-support-action>.
          Troveremo, tramite i nostri consulenti, una soluzione che passi tramite la prenotazione di alcuni servizi con il credito disponibile e altri servizi separatamente.
        </p>
      </b-container>
    </section>

    <section class="section">
      <div class="static-page__form" id="contattaci">
        <b-container>
          <form-contatti
            :formTitle="title_request_form"
            :formSubTitle="subtitle_request_form"
            :label="'form-contatti-viaggia-con-noi'"
            :recipient="config.site.emailSupport"
          />
        </b-container>
      </div>
    </section>

  </div>
</template>


<script>
import Vue from "vue";
import FormContatti from '@components/blocks/form-contatti.vue'
import ValueProposition from '@library/blocks/value-proposition.vue'
import ServicesInsurance from '@alpitour/components/blocks/detail/assicurazione-medico-bagaglio.vue'

export default {
  name: 'viaggia-con-noi',
  components:{
    'form-contatti': FormContatti,
    'value-proposition': ValueProposition,
    'services-insurance': ServicesInsurance,
  },
  props: {
  },
  created() {
  },
  data () {
    return {
      config: Vue.prototype.$config,
      site: Vue.prototype.$config.site,
      title_request_form: 'Hai bisogno di <span class=\'text-secondary\'>maggiori informazioni?</span> Contattaci!',
      subtitle_request_form: 'Compila il seguente form oppure scrivi una mail a <a href=\'mailto:' + Vue.prototype.$config.site.emailSupport + '\'>' + Vue.prototype.$config.site.emailSupport + '</a>',
    }
  },
  computed: {
  },
}
</script>


<style lang="scss">
.faq {
  .services-insurance {
    background-color: transparent !important;
    padding: 0 !important;
    margin: 0 !important;
    h2 {
      display: none !important;
    }
  }
}
</style>